var _a, _b, _c, _d, _e, _f, _g, _h;
import { TABLET_WIDTH } from "@codex/utils/constants";
var styles = (_a = {
        root: {
            width: 462,
            height: 569,
            padding: '47px 0px',
            // boxShadow: '0 15px 39px 0 rgba(35, 65, 81, 0.27)',
            backgroundColor: '#ffffff',
            margin: '0 auto',
        },
        title: {
            fontFamily: 'Assistant Extra Bold',
            fontSize: 34,
            fontWeight: 800,
            fontStyle: 'normal',
            fontStretch: 'normal',
            lineHeight: 0.65,
            letterSpacing: 'normal',
            textAlign: 'center',
            color: '#4bb0dd',
            marginBottom: 29,
        },
        subTitle: (_b = {
                fontSize: 20,
                fontWeight: 'bold',
                fontStyle: 'normal',
                fontStretch: 'normal',
                lineHeight: 1.1,
                fontFamily: 'Assistant Bold',
                letterSpacing: 'normal',
                textAlign: 'center',
                color: '#5a5a6c'
            },
            _b['& span'] = {
                fontFamily: 'OpenSansHebrew Extra Bold',
            },
            _b),
        blueAgree: (_c = {
                color: '#4bb0dd'
            },
            _c["&:hover"] = {
                textDecoration: "underline"
            },
            _c),
        form: (_d = {
                direction: "rtl",
                marginTop: 34,
                padding: '0px 78px'
            },
            _d['& label'] = {
                fontSize: 16,
                fontWeight: 'normal',
                fontStyle: 'normal',
                fontStretch: 'normal',
                lineHeight: 1.5,
                letterSpacing: 'normal',
                textAlign: 'right',
                color: '#5a5a6c',
            },
            _d),
        largeInput: {
            width: 306,
            height: 54,
            borderRadius: 6,
            border: 'solid 1px #e0dede',
            backgroundColor: '#ffffff',
        },
        btn: (_e = {
                width: 210,
                height: 43,
                borderRadius: 25.4,
                backgroundColor: '#f2648b',
                display: "block",
                margin: "0 auto",
                bottom: 15
            },
            _e['& span'] = {
                fontSize: 16,
                fontWeight: 'bold',
                fontStyle: 'normal',
                fontStretch: 'normal',
                lineHeight: 'normal',
                letterSpacing: 'normal',
                textAlign: 'center',
                color: '#ffffff',
            },
            _e['&:hover'] = {
                backgroundColor: '#f2648b',
            },
            _e['&:focus'] = {
                backgroundColor: '#f2648b',
            },
            _e['&.with-error'] = {
                marginTop: 10
            },
            _e),
        rgstrLink: {
            // width: 148,
            height: 24,
            fontSize: 16,
            textDecoration: 'underline',
            fontWeight: 'normal',
            fontStyle: 'normal',
            fontStretch: 'normal',
            lineHeight: 1.5,
            letterSpacing: 'normal',
            textAlign: 'center',
            color: '#4bb0dd',
            display: "block",
            margin: '0 auto'
        },
        chckBx: (_f = {},
            _f['& .anticon'] = {
                display: "none"
            },
            _f["& .has-error"] = (_g = {},
                _g["& .ant-checkbox-inner"] = {
                    borderColor: '#f5222d'
                },
                _g),
            _f)
    },
    _a["@media screen and (max-width:" + TABLET_WIDTH + "px)"] = {
        root: {
            width: 320,
            height: 483,
            padding: '28px 0px'
        },
        title: {
            marginBottom: 15,
        },
        subTitle: {
            fontSize: 18,
        },
        form: (_h = {
                marginTop: 22,
                padding: '0px 20px'
            },
            _h['& label'] = {
                fontSize: 14,
                lineHeight: 1.71,
            },
            _h),
        largeInput: {
            width: 282,
        },
        rgstrLink: {
            fontSize: 14,
            fontFamily: 'Assistant'
        },
        btn: {
            width: 176,
        }
    },
    _a);
export default styles;



//////////////////
// WEBPACK FOOTER
// ./src/components/LoginForm/styles.ts
// module id = 839
// module chunks = 0